import axios from 'axios'

export const getColorsCards = (headers) => async (dispatch) => {

    try {

        dispatch({
            type: 'GET_COLORS_CARDS_PENDING'
        })

        const { data } = await axios.get(process.env.REACT_APP_API_ENDPOINT + '/colorcards', headers)

        if (data.status === "ok") {
            dispatch({
                type: 'GET_COLORS_CARDS_SUCCESS',
                payload: data

            })

        } else {
            dispatch({
                type: 'GET_COLORS_CARDS_FAILED',
                payload: data
            })
        }


    } catch (error) {
        dispatch({
            type: 'GET_COLORS_FAILED',
            payload: error.response && error.response.data.message
                ? error.response.data.message
                : error.message,
        })
    }
}